import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconWarning = function IconWarning(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.918 4.543c1.153-2.295 3.915-3.204 6.17-2.03a4.62 4.62 0 011.867 1.796l.126.234 19.415 34.663c1.153 2.295.26 5.108-1.993 6.282a4.52 4.52 0 01-1.816.504l-.272.008H4.584C2.052 46 0 43.9 0 41.332a4.74 4.74 0 01.387-1.876l.117-.25L19.918 4.543zM24 34a2 2 0 100 4 2 2 0 100-4zm-.048-17l-.184.013c-.976.1-1.728.9-1.766 1.853v.152l.416 10.502C22.45 30.346 23.15 31 24 31c.8 0 1.467-.58 1.57-1.336l.013-.144L26 18.943l-.006-.152c-.072-.9-.773-1.627-1.676-1.767l-.16-.02-.205-.005z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.918 4.543c1.153-2.295 3.915-3.204 6.17-2.03a4.62 4.62 0 011.867 1.796l.126.234 19.415 34.663c1.153 2.295.26 5.108-1.993 6.282a4.52 4.52 0 01-1.816.504l-.272.008H4.584C2.052 46 0 43.9 0 41.332a4.74 4.74 0 01.387-1.876l.117-.25L19.918 4.543zm4.78.63a1.516 1.516 0 00-1.99.55l-19.54 35c-.11.22-.168.465-.168.713 0 .816.612 1.487 1.393 1.56l.14.006h38.934c.243 0 .482-.06.698-.172a1.58 1.58 0 00.727-1.969l-.06-.137-19.467-34.87a1.55 1.55 0 00-.666-.681zM24 34a2 2 0 110 4 2 2 0 110-4zm-.048-17l.205.005c.98.074 1.762.833 1.838 1.786l.006.152-.417 10.577C25.55 30.346 24.85 31 24 31s-1.55-.654-1.583-1.48l-.416-10.502c-.04-1.02.738-1.89 1.766-2.005l.184-.013z"
  })));
};

export default IconWarning;
